import { render } from "./MagratheaCard.vue?vue&type=template&id=10336398"
import script from "./MagratheaCard.vue?vue&type=script&lang=js"
export * from "./MagratheaCard.vue?vue&type=script&lang=js"

import "./MagratheaCard.vue?vue&type=style&index=0&id=10336398&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__